<template>
    <div>
        <menu-bar></menu-bar>

        <div class="container" role="main">
            <div class="row" style="margin-top: 50px">

                <ol class="breadcrumb">
                    <li><a href="#/">INICIAL</a></li>
                    <li class="active">HABILITAR / DESABILITAR BURST NOS CONTRATOS</li>
                </ol>

                <div class="row">
                    <div class="col-md-12">

                        <form class="form-horizontal" >

                            <div class="panel panel-info">
                                <div class="panel-heading">DADS PERSONALIZADOS</div>
                                <div class="panel-body" >

                                    <div class="form-group">
                                        <div class="col-sm-4">
                                            <label for="minimo" class="control-label">GARANTIA DE BANDA MÍNIMA(%):</label>
                                            <input v-model.number="minimo" class="form-control" id="minimo">
                                        </div>

                                        <div class="col-sm-4">
                                            <label for="maximo" class="control-label">GARANTIA DE BANDA MÁXIMA(%):</label>
                                            <input v-model.number="maximo" class="form-control" id="maximo">
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <button type="button" @click="markAll()" class="btn btn-danger btn-xs">
                                HABILITAR BURST PARA TODOS</button>

                            <button type="button" @click="cancelAll()" class="btn btn-info btn-xs">
                                DESABILITAR BURST PARA TODOS</button>
                            <br/><br/>

                        </form>

                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
/* global swal */
import { Contratos } from "../../class/index";

export default {
    name: "Burst",
    data() {
        return {
            maximo: 50,
            minimo: 50
        };
    },
    methods: {
        markAll() {
            swal.queue([
                {
                    title: "Comandos",
                    confirmButtonText: "Enviar Comando",
                    text: "Posso habilitar o burst de todos?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            Contratos.burst(true, this.minimo, this.maximo)
                                .then(() => resolve())
                                .catch(err => {
                                    console.log(err);
                                    resolve();
                                });
                        });
                    }
                }
            ]);
        },
        cancelAll() {
            swal.queue([
                {
                    title: "Comandos",
                    confirmButtonText: "Enviar Comando",
                    text: "Posso desabilitar o burst de todos?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            Contratos.burst(false)
                                .then(() => resolve())
                                .catch(err => {
                                    console.log(err);
                                    resolve();
                                });
                        });
                    }
                }
            ]);
        }
    }
};
</script>
